import { render, staticRenderFns } from "./SettingsStagePointsPerKill.vue?vue&type=template&id=47915dd4&"
import script from "./SettingsStagePointsPerKill.vue?vue&type=script&lang=js&"
export * from "./SettingsStagePointsPerKill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports